define.alias("shared/utils/hex-to-rgb", "calendar/utils/hex-to-rgb");